import { DownOutlined, LoadingOutlined, PlusOutlined, SettingOutlined, UpOutlined, WarningOutlined } from '@ant-design/icons';
import type { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Pagination } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IConditionSV2, IVConditionFilterV2 } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { NodataTable } from '../../../../../../components/NoDataTable';
import '../../../style.scss';
import ModalAddCustomersManually from '../../Modal/ModalAddCustomersManually';
import ItemConditionDisplay from '../../ViewGroup/components/ItemConditionDisplay';
import { AddType, ISelectedCustomer, type IDataFilterGroupList, type IInforAddGroup, type IPagination } from '../AddNewGroup';
import { useCustomerGroupContext } from '../../../indexV2';
import { CONDITIONGROUP } from './PrivateGroup/AG_PrivateAutomatic';
import { formatNumber } from '../../../../../../services/mixin';
import { formatPrice } from '../../../../../../until';



interface Props {
    loadingTableModal: boolean

    memoizedColumnDefs: ColDef<any, any>[];
    paginationCustomers: IPagination

    selectedIdCustomerV9: ISelectedCustomer[]

    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>

    onPaginationChange: (page: number, pageSize: number) => void;

    //Kh có dk 
    dataFilterListCondUnmatchedCustomers: IDataFilterGroupList


    tableDataCondMatchedCustomers: any[];
    tableDataCondUnmatchedCustomers: any[];

    infoOperator: IVConditionFilterV2
    selectedIdCondUnmatchedCustomers: Set<number>

    paginationCondMatchedCustomers: IPagination;
    paginationCondUnmatchedCustomers: IPagination;

    setSelectedIdUnmatchedCustomers: (data: Set<number>) => void;
    setDataFilterListCondUnmatchedCustomers: (dataFilterList: IDataFilterGroupList) => void;
    onPaginationCondMatchedCustomers: (page: number, pageSize: number) => void;
    onPaginationCondUnmatchedCustomers: (page: number, pageSize: number) => void;

    setModalCondition: (visible: boolean) => void;
    //Kh có dk

    tableDataCondAll: any[]
}

const AG_CustomerList: React.FC<Props> = ({
    loadingTableModal,
    memoizedColumnDefs,
    paginationCustomers,

    selectedIdCustomerV9,

    setSelectedIdCustomerV9,

    onPaginationChange,

    //Kh có dk 
    dataFilterListCondUnmatchedCustomers,


    tableDataCondMatchedCustomers,
    tableDataCondUnmatchedCustomers,

    infoOperator,
    selectedIdCondUnmatchedCustomers,

    paginationCondMatchedCustomers,
    paginationCondUnmatchedCustomers,

    setSelectedIdUnmatchedCustomers,
    setDataFilterListCondUnmatchedCustomers,
    onPaginationCondMatchedCustomers,
    onPaginationCondUnmatchedCustomers,

    setModalCondition,
    //Kh có dk

    tableDataCondAll,
}) => {
    const {
        isModalLoadingSync, isLoadingListUnmatchedSync,
        handleOpenDataFields
    } = useCustomerGroupContext();


    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);

    const [isMore, setMore] = useState<boolean>(true)
    const [isModalAddCustomersManually, setModalAddCustomersManually] = useState<boolean>(false)

    const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());

    //------------------------------------ Start SELECT
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

        const currentPageIds = (infoOperator.typeCondition === CONDITIONGROUP.ALL ? tableDataCondAll : tableDataCondMatchedCustomers ?? []).map((row: any) => Number(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIds);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: number[] = [];
        const removed: number[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIds.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        setSelectedIds(nextSet);

        // 👉 Cập nhật danh sách selected account
        handleChangeSelectedCustomer(added, removed);

    }, [selectedIds, tableDataCondMatchedCustomers, tableDataCondAll]);

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {
        setSelectedIdCustomerV9((prev) =>
            itemsAdd.length ?
                [
                    ...prev,
                    ...itemsAdd
                        .filter((id) => !prev.some((u) => u.customerId === id))
                        .map((id) => ({ customerId: id, addType: AddType.Auto })),
                ] :
                itemsRemove.length ?
                    prev.filter((u) => !itemsRemove.includes(u.customerId)) :
                    prev
        );
    };



    const onSelectionChangedV9 = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;

        // Chuẩn hóa n.data về dạng ISelectedCustomer
        const selectedCustomersOnPage: ISelectedCustomer[] = api.getSelectedNodes()
            .filter(n => n.data)
            .map((n) => ({
                customerId: Number(n.data.id),
                addType: n.data.addType ?? AddType.Manual,
            }));

        // Toàn bộ customerId trên TRANG hiện tại
        const currentPageCustomerIds = (
            infoOperator.typeCondition === CONDITIONGROUP.ALL
                ? tableDataCondAll
                : tableDataCondMatchedCustomers ?? []
        ).map((row: any) => Number(row.customerId ?? row.id));

        const nextSet = new Set(selectedIds);
        const added: ISelectedCustomer[] = [];
        const removed: ISelectedCustomer[] = [];

        for (const customerId of currentPageCustomerIds) {
            const isCurrentlySelected = selectedCustomersOnPage.some(c => c.customerId === customerId);
            const wasPreviouslySelected = selectedIds.has(customerId);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                const found = selectedCustomersOnPage.find(c => c.customerId === customerId);
                added.push(found!);
                nextSet.add(customerId);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                removed.push({ customerId, addType: AddType.Manual });
                nextSet.delete(customerId);
            }
        }

        setSelectedIds(nextSet);
        handleChangeSelectedCustomerV9(added, removed);

    }, [selectedIds, tableDataCondMatchedCustomers, tableDataCondAll]);


    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedCustomerV9 = (itemsAdd: ISelectedCustomer[] = [], itemsRemove: ISelectedCustomer[] = []) => {
        setSelectedIdCustomerV9((prev) =>
            itemsAdd.length
                ? [
                    ...prev,
                    ...itemsAdd.filter(
                        (addItem) => !prev.some((p) => p.customerId === addItem.customerId)
                    ),
                ]
                : itemsRemove.length
                    ? prev.filter(
                        (p) => !itemsRemove.some((r) => r.customerId === p.customerId)
                    )
                    : prev
        );
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && tableDataCondMatchedCustomers && tableDataCondAll.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(Number(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [tableDataCondMatchedCustomers, tableDataCondAll, selectedIds]);

    //------------------------------------ End SELECT

    useEffect(() => {
        const Ids = new Set(
            selectedIdCustomerV9.map(item => item.customerId)
        );
        setSelectedIds(Ids);
    }, [selectedIdCustomerV9])



    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white px-4 rounded">
            <ModalAddCustomersManually
                loadingTableModal={loadingTableModal}
                isOpen={isModalAddCustomersManually}
                dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
                memoizedColumnDefs={memoizedColumnDefs}
                tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}
                paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}
                selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}
                setSelectedIdCondUnmatchedCustomers={setSelectedIdUnmatchedCustomers}
                setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
                onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}
                closeModal={setModalAddCustomersManually}
            />
            {/* Header */}
            <div className="custom-page-css flex flex-col border-b pb-2">
                <div className="custom-page-css w-full flex items-center justify-betweeen gap-2">
                    <span className='custom-page-css text-lg font-medium whiteSpace-nowrap'>Điều kiện nhóm</span>
                    <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                        onClick={() => setModalCondition(true)}
                    >
                        <div className="custom-page-css flex items-center justify-center rounded-full bg-E1E4E9 p-2px ">
                            <PlusOutlined style={{ color: '#98A2B3' }} />
                        </div>
                        <span className="custom-page-css text-base text-667085 font-medium">Thiết lập điều kiện
                            <span className="custom-page-css text-base text-1890FF font-medium">({infoOperator.conditions.length} tiêu chí đang áp dụng)</span>
                        </span>
                    </div>

                </div>
                <div className="custom-page-css flex flex-col gap-1">
                    <span className='custom-page-css text-sm text-344054 font-regular'>Áp dụng cho module</span>
                    <span className='custom-page-css text-lg text-344054 font-bold'>Danh sách khách hàng</span>
                </div>

            </div>

            <div className={`${infoOperator.typeCondition !== CONDITIONGROUP.ALL ? '' : 'd-none'} custom-page-css flex flex-col border-b pb-2`}>
                <div className="custom-page-css w-full flex flex-1 items-center justify-between gap-2">
                    <div className="custom-page-css flex items-center gap-2">
                        <span className='custom-page-css text-lg font-medium whiteSpace-nowrap'>Điều kiện lọc</span>


                    </div>
                    {(isMore) ?
                        <UpOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
                        :
                        <DownOutlined className='custom-page-css text-base text-98A2B3' onClick={() => setMore(!isMore)} />
                    }
                </div>
                {isMore &&
                    <div className="custom-page-css flex flex-col gap-2 flex-1">
                        <div className="custom-page-css flex gap-2 flex-1">
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Trường</span>

                            </div>
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Điều kiện</span>
                            </div>
                            <div className="custom-page-css flex flex-col gap-2 flex-1">
                                <span className='custom-page-css text-base text-344054 font-medium'>Giá trị</span>
                            </div>
                        </div>
                        <div className="custom-page-css flex flex-col flex-1">
                            {
                                infoOperator.conditions.map((item, i) => (
                                    <div
                                        key={i}
                                        className="custom-page-css flex gap-2 flex-1"
                                    >
                                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                                            <span className='custom-page-css text-base text-344054 font-regular'>
                                                {
                                                    infoOperator.typeCondition === 1 && i !== 0 &&
                                                    <span className='pr-2'>  {item.logicOperator}</span>
                                                }
                                                {item.CustomerField?.label}
                                            </span>
                                        </div>
                                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                                            <span className='custom-page-css text-base text-344054 font-regular'>
                                                {item.condition?.label}
                                            </span>
                                        </div>
                                        <div className="custom-page-css flex gap-2 flex-1">
                                            <ItemConditionDisplay
                                                item={item}
                                            />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
            </div>



            <div className="custom-page-css flex gap-2 items-center justify-between">
                <span className="custom-page-css text-lg font-medium">Xem trước danh sách khách hàng của nhóm</span>

                <span className="custom-page-css text-FF4D4F text-base font-regular"><WarningOutlined className='custom-page-css text-sm text-FF4D4F' /> (Danh sách khách hàng sẽ thay đổi theo điều kiện)</span>
            </div>


            {/* Counter */}
            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className="custom-page-css text-base text-4B4B4B font-regular">Đã chọn:</span>
                    {/* <span className="custom-page-css text-base text-344054 font-regular">{infoOperator.typeCondition === CONDITIONGROUP.ALL ? paginationCustomers.total : paginationCondMatchedCustomers.total} khách hàng</span> */}

                    <span className="custom-page-css text-base text-344054 font-regular">{formatPrice(selectedIdCustomerV9.length)} khách hàng</span>
                </div>

                <div className="custom-page-css flex items-center justify-end gap-2">
                    {
                        isLoadingListUnmatchedSync ? (
                            <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                            >
                                <div className="custom-page-css flex items-center justify-center  p-2px rounded-full bg-E1E4E9 "
                                >
                                    <LoadingOutlined style={{ color: '#096DD9' }} />
                                </div>
                                <span className="custom-page-css text-base text-667085 font-medium">Đang đồng bộ dữ liệu!</span>
                            </div>
                        ) : (
                            <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                                onClick={() => setModalAddCustomersManually(true)}
                            >
                                <div className="custom-page-css flex items-center justify-center  p-2px rounded-full bg-E1E4E9 "

                                >
                                    <PlusOutlined style={{ color: '#98A2B3' }} />
                                </div>
                                <span className="custom-page-css text-base text-667085 font-medium">Thêm khách hàng thủ công</span>
                            </div>
                        )
                    }

                    <div className="btn-input t-px-8 cursor-pointer"
                        onClick={handleOpenDataFields}
                    >
                        <div className="icon-svg">
                            <SettingOutlined />
                        </div>
                    </div>
                </div>
            </div>

            {/* Grid */}

            <div className={`order-history-card__body `}>
                <div className="ag-theme-alpine custom-table-ag  custom-css-table" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        columnDefs={memoizedColumnDefs}
                        rowData={infoOperator.typeCondition === CONDITIONGROUP.ALL ? tableDataCondAll : tableDataCondMatchedCustomers}
                        rowHeight={55}
                        defaultColDef={{
                            resizable: true
                        }}
                        overlayNoRowsTemplate={NodataTable}

                        rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                        getRowId={getRowId}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                    />
                    {
                        isModalLoadingSync && (
                            <div className="table-loading-overlay">
                                <LoadingOutlined className="custom-page-css text-xl " />
                                <span className="text-sm font-medium text-344054">Đang đồng bộ dữ liệu!</span>
                            </div>
                        )
                    }
                </div>

                {/* Pagination */}
                {infoOperator.typeCondition === CONDITIONGROUP.ALL
                    ?
                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block">
                            <Pagination
                                showSizeChanger
                                current={paginationCustomers.current}
                                pageSize={paginationCustomers.pageSize}
                                total={paginationCustomers.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                className="rs-pagination"
                                onChange={onPaginationChange}
                            />
                        </div>
                    </ConfigProvider>
                    :
                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block">
                            <Pagination
                                showSizeChanger
                                current={paginationCondMatchedCustomers.current}
                                pageSize={paginationCondMatchedCustomers.pageSize}
                                total={paginationCondMatchedCustomers.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                className="rs-pagination"
                                onChange={onPaginationCondMatchedCustomers}
                            />
                        </div>
                    </ConfigProvider>

                }
            </div>

        </div>
    );
};

export default React.memo(AG_CustomerList)